export default __webpack_public_path__ + "ece15db4b88fe43e95ad387fce9cb8db.svg";